import Vue from 'vue'
import Router from 'vue-router'

/* 관리자 분야 */
import AdminLogin from '@/components/Admin/Login/AdminLogin'
import AdminMain from '@/components/Admin/Main/AdminMain'
import AdminMenuPermissionManagement from '@/components/Admin/SystemManagement/AdminMenuPermissionManagement'
import AdminMenuPermissionManagementAdd from '@/components/Admin/SystemManagement/AdminMenuPermissionManagementAdd'
import AdminManagement from '@/components/Admin/SystemManagement/AdminManagement'
import AdminManagementAdd from '@/components/Admin/SystemManagement/AdminManagementAdd'
import AdminHotKeywordManagement from '@/components/Admin/SystemManagement/AdminHotKeywordManagement'
import AdminInformationUseManagement from '@/components/Admin/SystemManagement/AdminInformationUseManagement'
import AdminCancellationRefundPolicyManagement from '@/components/Admin/SystemManagement/AdminCancellationRefundPolicyManagement'
import AdminMessageLogManagement from '@/components/Admin/SystemManagement/AdminMessageLogManagement'
import AdminPointLogManagement from '@/components/Admin/SystemManagement/AdminPointLogManagement'
import AdminPopupManagement from '@/components/Admin/SystemManagement/AdminPopupManagement'
import AdminPopupManagementAdd from '@/components/Admin/SystemManagement/AdminPopupManagementAdd'
import AdminSendMessage from '@/components/Admin/SystemManagement/AdminSendMessage'
import AdminBenefitsManagement from '@/components/Admin/SystemManagement/AdminBenefitsManagement'
import AdminCustomerManagement from '@/components/Admin/CustomerManagement/AdminCustomerManagement'
import AdminCustomerManagementAdd from '@/components/Admin/CustomerManagement/AdminCustomerManagementAdd'
import AdminPerformanceManagement from '@/components/Admin/MenuManagement/AdminPerformanceManagement'
import AdminPerformanceManagementAdd from '@/components/Admin/MenuManagement/AdminPerformanceManagementAdd'
import AdminPartnerManagement from '@/components/Admin/FooterManagement/AdminPartnerManagement'
import AdminPartnerManagementAdd from '@/components/Admin/FooterManagement/AdminPartnerManagementAdd'
import AdminRollingBannerManagement from '@/components/Admin/MainManagement/AdminRollingBannerManagement'
import AdminRollingBannerManagementAdd from '@/components/Admin/MainManagement/AdminRollingBannerManagementAdd'
import AdminRecommendBannerManagement from '@/components/Admin/MainManagement/AdminRecommendBannerManagement'
import AdminRecommendBannerManagementAdd from '@/components/Admin/MainManagement/AdminRecommendBannerManagementAdd'
import AdminRecommendMonthBannerManagement from '@/components/Admin/MainManagement/AdminRecommendMonthBannerManagement'
import AdminFixBannerManagement from '@/components/Admin/MainManagement/AdminFixBannerManagement'
import AdminNoticeManagement from '@/components/Admin/CommunityManagement/AdminNoticeManagement'
import AdminNoticeManagementAdd from '@/components/Admin/CommunityManagement/AdminNoticeManagementAdd'
import AdminTravelReviewManagement from '@/components/Admin/CommunityManagement/AdminTravelReviewManagement'
import AdminTravelReviewManagementAdd from '@/components/Admin/CommunityManagement/AdminTravelReviewManagementAdd'
import AdminOnlineInquiryManagement from '@/components/Admin/CommunityManagement/AdminOnlineInquiryManagement'
import AdminOnlineInquiryManagementAdd from '@/components/Admin/CommunityManagement/AdminOnlineInquiryManagementAdd'
import AdminFrequentlyQuestionsManagement from '@/components/Admin/CommunityManagement/AdminFrequentlyQuestionsManagement'
import AdminFrequentlyQuestionsManagementAdd from '@/components/Admin/CommunityManagement/AdminFrequentlyQuestionsManagementAdd'
import AdminGroupInquiryManagement from '@/components/Admin/CommunityManagement/AdminGroupInquiryManagement'
import AdminGroupInquiryManagementAdd from '@/components/Admin/CommunityManagement/AdminGroupInquiryManagementAdd'
import AdminTravelTypeManagement from '@/components/Admin/TravelManagement/AdminTravelTypeManagement'
import AdminTravelTypeManagementAdd from '@/components/Admin/TravelManagement/AdminTravelTypeManagementAdd'
import AdminTravelProductManagement from '@/components/Admin/TravelManagement/AdminTravelProductManagement'
import AdminTravelProductManagementAdd from '@/components/Admin/TravelManagement/AdminTravelProductManagementAdd'
import AdminScheduleManagement from '@/components/Admin/TravelManagement/AdminScheduleManagement'
import AdminScheduleManagementAdd from '@/components/Admin/TravelManagement/AdminScheduleManagementAdd'
import AdminTmsManagement from '@/components/Admin/TravelManagement/AdminTmsManagement'
import AdminReservationManagement from '@/components/Admin/ReservationManagement/AdminReservationManagement'
import AdminReservationManagementAdd from '@/components/Admin/ReservationManagement/AdminReservationManagementAdd'
import AdminImmediatePaymentManagement from '@/components/Admin/ReservationManagement/AdminImmediatePaymentManagement'

/* 홈페이지 분야 */
import Main from '@/components/Homepage/Main/Main'
import Login from '@/components/Homepage/Login/Login'
import KaKaoLogin from '@/components/Homepage/Login/KaKaoLogin'
import NaverLogin from '@/components/Homepage/Login/NaverLogin'
import Search from '@/components/Homepage/Login/Search'
import Join from '@/components/Homepage/Join/Join'
import TravelProduct from '@/components/Homepage/Travel/TravelProduct'
import TravelProductDetail from '@/components/Homepage/Travel/TravelProductDetail'
import ReservationLogin from '@/components/Homepage/Reservation/ReservationLogin'
import Reservation from '@/components/Homepage/Reservation/Reservation'
import ReservationImmediate from '@/components/Homepage/Reservation/ReservationImmediate'
import ReservationSuccess from '@/components/Homepage/Reservation/ReservationSuccess'
import ReservationSuccessImmediate from '@/components/Homepage/Reservation/ReservationSuccessImmediate'
import ReservationStatus from '@/components/Homepage/Reservation/ReservationStatus'
import ReservationMobileFail from '@/components/Homepage/Reservation/ReservationMobileFail'
import My from '@/components/Homepage/My/My'
import Community from '@/components/Homepage/Community/Community'
import CommunityWrite from '@/components/Homepage/Community/CommunityWrite'
import NoticeDetail from '@/components/Homepage/Community/NoticeDetail'
import TravelReviewDetail from '@/components/Homepage/Community/TravelReviewDetail'
import OnlineInquiryDetail from '@/components/Homepage/Community/OnlineInquiryDetail'
import FrequentlyQuestionsDetail from '@/components/Homepage/Community/FrequentlyQuestionsDetail'
import CompanyIntroduction from '@/components/Homepage/CompanyIntroduction/CompanyIntroduction'
import Performance from '@/components/Homepage/Performance/Performance'
import PerformanceDetail from '@/components/Homepage/Performance/PerformanceDetail'
import TermsAndPolicies from '@/components/Homepage/TermsAndPolicies/TermsAndPolicies'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    /* 이상한 주소 처리 */
    {
      path: '*',
      redirect: '/'
    },
    /* 관리자 분야 */
    {
      path: '/AdminLogin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/AdminMain',
      name: 'AdminMain',
      component: AdminMain
    },
    {
      path: '/AdminMenuPermissionManagement',
      name: 'AdminMenuPermissionManagement',
      component: AdminMenuPermissionManagement
    },
    {
      path: '/AdminMenuPermissionManagementAdd',
      name: 'AdminMenuPermissionManagementAdd',
      component: AdminMenuPermissionManagementAdd
    },
    {
      path: '/AdminManagement',
      name: 'AdminManagement',
      component: AdminManagement
    },
    {
      path: '/AdminManagementAdd',
      name: 'AdminManagementAdd',
      component: AdminManagementAdd
    },
    {
      path: '/AdminHotKeywordManagement',
      name: 'AdminHotKeywordManagement',
      component: AdminHotKeywordManagement
    },
    {
      path: '/AdminInformationUseManagement',
      name: 'AdminInformationUseManagement',
      component: AdminInformationUseManagement
    },
    {
      path: '/AdminCancellationRefundPolicyManagement',
      name: 'AdminCancellationRefundPolicyManagement',
      component: AdminCancellationRefundPolicyManagement
    },
    {
      path: '/AdminMessageLogManagement',
      name: 'AdminMessageLogManagement',
      component: AdminMessageLogManagement
    },
    {
      path: '/AdminPointLogManagement',
      name: 'AdminPointLogManagement',
      component: AdminPointLogManagement
    },
    {
      path: '/AdminPopupManagement',
      name: 'AdminPopupManagement',
      component: AdminPopupManagement
    },
    {
      path: '/AdminPopupManagementAdd',
      name: 'AdminPopupManagementAdd',
      component: AdminPopupManagementAdd
    },
    {
      path: '/AdminSendMessage',
      name: 'AdminSendMessage',
      component: AdminSendMessage
    },
    {
      path: '/AdminBenefitsManagement',
      name: 'AdminBenefitsManagement',
      component: AdminBenefitsManagement
    },
    {
      path: '/AdminCustomerManagement',
      name: 'AdminCustomerManagement',
      component: AdminCustomerManagement
    },
    {
      path: '/AdminCustomerManagementAdd',
      name: 'AdminCustomerManagementAdd',
      component: AdminCustomerManagementAdd
    },
    {
      path: '/AdminPerformanceManagement',
      name: 'AdminPerformanceManagement',
      component: AdminPerformanceManagement
    },
    {
      path: '/AdminPerformanceManagementAdd',
      name: 'AdminPerformanceManagementAdd',
      component: AdminPerformanceManagementAdd
    },
    {
      path: '/AdminPartnerManagement',
      name: 'AdminPartnerManagement',
      component: AdminPartnerManagement
    },
    {
      path: '/AdminPartnerManagementAdd',
      name: 'AdminPartnerManagementAdd',
      component: AdminPartnerManagementAdd
    },
    {
      path: '/AdminRollingBannerManagement',
      name: 'AdminRollingBannerManagement',
      component: AdminRollingBannerManagement
    },
    {
      path: '/AdminRollingBannerManagementAdd',
      name: 'AdminRollingBannerManagementAdd',
      component: AdminRollingBannerManagementAdd
    },
    {
      path: '/AdminRecommendBannerManagement',
      name: 'AdminRecommendBannerManagement',
      component: AdminRecommendBannerManagement
    },
    {
      path: '/AdminRecommendBannerManagementAdd',
      name: 'AdminRecommendBannerManagementAdd',
      component: AdminRecommendBannerManagementAdd
    },
    {
      path: '/AdminRecommendMonthBannerManagement',
      name: 'AdminRecommendMonthBannerManagement',
      component: AdminRecommendMonthBannerManagement
    },
    {
      path: '/AdminFixBannerManagement',
      name: 'AdminFixBannerManagement',
      component: AdminFixBannerManagement
    },
    {
      path: '/AdminNoticeManagement',
      name: 'AdminNoticeManagement',
      component: AdminNoticeManagement
    },
    {
      path: '/AdminNoticeManagementAdd',
      name: 'AdminNoticeManagementAdd',
      component: AdminNoticeManagementAdd
    },
    {
      path: '/AdminTravelReviewManagement',
      name: 'AdminTravelReviewManagement',
      component: AdminTravelReviewManagement
    },
    {
      path: '/AdminTravelReviewManagementAdd',
      name: 'AdminTravelReviewManagementAdd',
      component: AdminTravelReviewManagementAdd
    },
    {
      path: '/AdminOnlineInquiryManagement',
      name: 'AdminOnlineInquiryManagement',
      component: AdminOnlineInquiryManagement
    },
    {
      path: '/AdminOnlineInquiryManagementAdd',
      name: 'AdminOnlineInquiryManagementAdd',
      component: AdminOnlineInquiryManagementAdd
    },
    {
      path: '/AdminFrequentlyQuestionsManagement',
      name: 'AdminFrequentlyQuestionsManagement',
      component: AdminFrequentlyQuestionsManagement
    },
    {
      path: '/AdminFrequentlyQuestionsManagementAdd',
      name: 'AdminFrequentlyQuestionsManagementAdd',
      component: AdminFrequentlyQuestionsManagementAdd
    },
    {
      path: '/AdminGroupInquiryManagement',
      name: 'AdminGroupInquiryManagement',
      component: AdminGroupInquiryManagement
    },
    {
      path: '/AdminGroupInquiryManagementAdd',
      name: 'AdminGroupInquiryManagementAdd',
      component: AdminGroupInquiryManagementAdd
    },
    {
      path: '/AdminTravelTypeManagement',
      name: 'AdminTravelTypeManagement',
      component: AdminTravelTypeManagement
    },
    {
      path: '/AdminTravelTypeManagementAdd',
      name: 'AdminTravelTypeManagementAdd',
      component: AdminTravelTypeManagementAdd
    },
    {
      path: '/AdminTravelProductManagement',
      name: 'AdminTravelProductManagement',
      component: AdminTravelProductManagement
    },
    {
      path: '/AdminTravelProductManagementAdd',
      name: 'AdminTravelProductManagementAdd',
      component: AdminTravelProductManagementAdd
    },
    {
      path: '/AdminScheduleManagement',
      name: 'AdminScheduleManagement',
      component: AdminScheduleManagement
    },
    {
      path: '/AdminScheduleManagementAdd',
      name: 'AdminScheduleManagementAdd',
      component: AdminScheduleManagementAdd
    },
    {
      path: '/AdminTmsManagement',
      name: 'AdminTmsManagement',
      component: AdminTmsManagement
    },
    {
      path: '/AdminReservationManagement',
      name: 'AdminReservationManagement',
      component: AdminReservationManagement
    },
    {
      path: '/AdminReservationManagementAdd',
      name: 'AdminReservationManagementAdd',
      component: AdminReservationManagementAdd
    },
    {
      path: '/AdminImmediatePaymentManagement',
      name: 'AdminImmediatePaymentManagement',
      component: AdminImmediatePaymentManagement
    },
    /* 홈페이지 분야 */
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/KaKaoLogin',
      name: 'KaKaoLogin',
      component: KaKaoLogin
    },
    {
      path: '/NaverLogin',
      name: 'NaverLogin',
      component: NaverLogin
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join
    },
    {
      path: '/TravelProduct',
      name: 'TravelProduct',
      component: TravelProduct
    },
    {
      path: '/TravelProductDetail',
      name: 'TravelProductDetail',
      component: TravelProductDetail
    },
    {
      path: '/ReservationLogin',
      name: 'ReservationLogin',
      component: ReservationLogin
    },
    {
      path: '/Reservation',
      name: 'Reservation',
      component: Reservation
    },
    {
      path: '/ReservationImmediate',
      name: 'ReservationImmediate',
      component: ReservationImmediate
    },
    {
      path: '/ReservationSuccess',
      name: 'ReservationSuccess',
      component: ReservationSuccess
    },
    {
      path: '/ReservationSuccessImmediate',
      name: 'ReservationSuccessImmediate',
      component: ReservationSuccessImmediate
    },
    {
      path: '/ReservationStatus',
      name: 'ReservationStatus',
      component: ReservationStatus
    },
    {
      path: '/ReservationMobileFail',
      name: 'ReservationMobileFail',
      component: ReservationMobileFail
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
    {
      path: '/Community',
      name: 'Community',
      component: Community
    },
    {
      path: '/CommunityWrite',
      name: 'CommunityWrite',
      component: CommunityWrite
    },
    {
      path: '/NoticeDetail',
      name: 'NoticeDetail',
      component: NoticeDetail
    },
    {
      path: '/TravelReviewDetail',
      name: 'TravelReviewDetail',
      component: TravelReviewDetail
    },
    {
      path: '/OnlineInquiryDetail',
      name: 'OnlineInquiryDetail',
      component: OnlineInquiryDetail
    },
    {
      path: '/FrequentlyQuestionsDetail',
      name: 'FrequentlyQuestionsDetail',
      component: FrequentlyQuestionsDetail
    },
    {
      path: '/CompanyIntroduction',
      name: 'CompanyIntroduction',
      component: CompanyIntroduction
    },
    {
      path: '/Performance',
      name: 'Performance',
      component: Performance
    },
    {
      path: '/PerformanceDetail',
      name: 'PerformanceDetail',
      component: PerformanceDetail
    },
    {
      path: '/TermsAndPolicies',
      name: 'TermsAndPolicies',
      component: TermsAndPolicies
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js